<template>
  <div :class="bem({ open: isOpen, nestedDrawerOpen: !!activeSubMenu?.activeIndex })">
    <div
      :class="bem('overlay')"
      @click="pageStore.toggleNavSidebarOpen(!isOpen)"
    />
    <nav :class="bem('drawer', { increasedWidth: activeSubMenuHasIncreasedWidth })">
      <header :class="bem('header')">
        <VisionLink :is-button="true" :class="bem('back-button')" @click="toggleLevel2Menu(null)">
          <span :class="bem('back-wrapper', { visible: !!activeSubMenu?.activeIndex || !!activeSecondarySubMenu?.activeIndex })">
            <VisionIcon icon="arrow" :rotate="180" colour="black" size="x-small"/>
            <span :class="bem('back-text')">
              {{ activeSubMenu?.title || activeSecondarySubMenu?.title || '-' }}
            </span>
          </span>
        </VisionLink>
        <button :class="bem('close')" @click="pageStore.toggleNavSidebarOpen(false)">
          <VisionIcon
            colour="black"
            icon="close"
            size="x-small"
          />
        </button>
      </header>
      <div :class="bem('main')">
        <ul :class="bem('items')">
          <!-- Side Menu List 1 -->
          <li v-for="(mainNavigationItem, mainNavigationItemIndex) in props.mainNavigationItems" :key="'level-1-item-' + mainNavigationItemIndex" :class="bem('items-wrapper')">
            <ul>
              <li>
                <button
                  v-if="mainNavigationItem._modelApiKey === 'navigation_button'"
                  :class="bem('item', { button: true })"
                  @click="
                    toggleLevel2Menu({
                      activeIndex: mainNavigationItemIndex + 1,
                      title: mainNavigationItem.buttonText
                    })
                  "
                >
                  <span :class="bem('item-text')">
                    {{ mainNavigationItem.buttonText }}
                  </span>
                  <VisionIcon icon="arrow" colour="black" size="small"/>
                </button>
                <a
                  v-else-if="
                    mainNavigationItem._modelApiKey === 'navigation_link' &&
                    mainNavigationItem.internalLink?.slug
                  "
                  :class="bem('item', { link: true })"
                  :href="buildInternalLink(mainNavigationItem)"
                  @click="handleLevel1Event(mainNavigationItem.linkText)"
                >
                  <span :class="bem('item-text')">
                    {{ mainNavigationItem.linkText }}
                  </span>
                  <VisionIcon icon="arrow" colour="black" size="small"/>
                </a>
                <!-- Nested drawer -->
                <div
                  v-if="mainNavigationItem._modelApiKey === 'navigation_button' && mainNavigationItem?.nestedItems?.length"
                  :class="bem('nested-drawer', { active: activeSubMenu?.activeIndex === mainNavigationItemIndex + 1 })"
                >
                  <header :class="bem('header')">
                    <VisionLink :is-button="true" @click="toggleLevel2Menu(null)">
                      <span :class="bem('back-wrapper', { visible: !!activeSubMenu?.activeIndex })">
                        <VisionIcon icon="arrow" :rotate="180" colour="black" size="x-small"/>
                        <span :class="bem('back-text')">
                          {{ activeSubMenu?.title || '-' }}
                        </span>
                      </span>
                    </VisionLink>
                    <button :class="bem('close')" @click="pageStore.toggleNavSidebarOpen(false)">
                      <VisionIcon
                        colour="black"
                        icon="close"
                        size="x-small"
                      />
                    </button>
                  </header>
                  <ul :class="bem('items')">
                    <li
                      v-for="(nestedItem, nestedItemIndex) in mainNavigationItem?.nestedItems"
                      :key="'level-2-item-' + nestedItemIndex"
                      :class="bem('items-wrapper')"
                    >
                      <template v-if="nestedItem._modelApiKey === 'navigation_image_card_row'">
                        <div :class="bem('image-row', { count: nestedItem.items?.length })">
                          <div v-for="(imageCard, imageCardIndex) in nestedItem.items" :key="'level-2-image-card-row-' + imageCardIndex" :class="bem('image-card-wrapper')">
                            <VisionCard
                              :aspect-ratio="nestedItem.items?.length > 2 ? '1/1' : '16/9'"
                              :title="imageCard.cardTextPosition === 'bottom-card' ? imageCard.linkText : ''"
                              :link="buildInternalLink(imageCard)"
                              :class="bem('image-card', { titleBelowCard: imageCard.cardTextPosition === 'below-card' })"
                              @click="handleLevel2Event(imageCard, activeSubMenu?.title)"
                            >
                              <template
                                #image
                              >
                                <DatoCmsImage
                                  :data="imageCard.image.responsiveImage"
                                  object-fit="cover"
                                  :object-position="`${imageCard.image.focalPoint.x * 100}% ${
                                    imageCard.image.focalPoint.y * 100
                                  }%`"
                                  layout="fill"
                                  :class="bem('image')"
                                  placeholder-class="NavigationSidebar__image-placeholder"
                                  sizes="(max-width: 1280px) 100vw, 40vw"
                                />
                              </template>
                            </VisionCard>
                            <VisionLink
                              v-if="imageCard.cardTextPosition === 'below-card' && imageCard.linkText"
                              :class="bem('below-card-title')"
                              :to="buildInternalLink(imageCard)"
                              @click="handleLevel2Event(imageCard, activeSubMenu?.title)"
                            >
                              {{ imageCard.linkText }}
                              <span>
                                <VisionIcon icon="arrow" colour="black" size="x-small"/>
                              </span>
                            </VisionLink>
                          </div>
                        </div>
                      </template>

                      <a
                        v-else-if="
                          nestedItem._modelApiKey === 'navigation_link' &&
                          nestedItem.internalLink?.slug
                        "
                        :class="bem('item', { link: true })"
                        :href="buildInternalLink(nestedItem)"
                        @click="handleLevel2Event(nestedItem, mainNavigationItem.buttonText)"
                      >
                        <span :class="bem('item-text')">
                          {{ nestedItem.linkText }}
                        </span>
                        <VisionIcon icon="arrow" colour="black" size="small"/>
                      </a>
                    </li>
                  </ul>
                  <ul v-if="mainNavigationItem.secondaryNestedItems?.length" :class="bem('secondary-items')">
                    <li
                      v-for="(secondaryNestedItem, secondaryNestedItemIndex) in mainNavigationItem.secondaryNestedItems"
                      :key="'secondary-item-' + secondaryNestedItemIndex"
                    >
                      <a
                        v-if="
                          secondaryNestedItem._modelApiKey === 'navigation_link' &&
                          secondaryNestedItem.internalLink?.slug
                        "
                        :class="bem('secondary-item')"
                        :href="buildInternalLink(secondaryNestedItem)"
                        @click="handleLevel1Event(secondaryNestedItem.linkText)"
                      >
                        <span :class="bem('item-text')">
                          {{ secondaryNestedItem.linkText }}
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </li>
        </ul>
        <div :class="bem('utilities')">
          <ul v-if="secondaryNavigationItems?.length" :class="bem('secondary-items')">
            <li
              v-for="(secondaryNavigationItem, secondaryNavigationItemIndex) in secondaryNavigationItems"
              :key="'secondary-item-' + secondaryNavigationItemIndex"
            >
              <a
                v-if="
                  secondaryNavigationItem._modelApiKey === 'navigation_link' &&
                  secondaryNavigationItem.internalLink?.slug
                "
                :class="bem('secondary-item')"
                :href="buildInternalLink(secondaryNavigationItem)"
                @click="handleLevel1Event(secondaryNavigationItem.linkText)"
              >
                <span :class="bem('item-text')">
                  {{ secondaryNavigationItem.linkText }}
                </span>
              </a>
              <button
                v-if="secondaryNavigationItem._modelApiKey === 'navigation_button'"
                :class="bem('secondary-item')"
                @click="
                  toggleLevel2SecondaryMenu({
                    activeIndex: secondaryNavigationItemIndex + 1,
                    title: secondaryNavigationItem.buttonText
                  })
                "
              >
                <span :class="bem('item-text')">
                  {{ secondaryNavigationItem.buttonText }}
                </span>
              </button>
              <!-- Nested drawer -->
              <div
                v-if="secondaryNavigationItem._modelApiKey === 'navigation_button' && secondaryNavigationItem?.nestedItems?.length"
                :class="bem('nested-drawer', { active: activeSecondarySubMenu?.activeIndex === secondaryNavigationItemIndex + 1 })"
              >
                <header :class="bem('header')">
                  <VisionLink :is-button="true" @click="toggleLevel2Menu(null)">
                    <span :class="bem('back-wrapper', { visible: !!activeSubMenu?.activeIndex || !!activeSecondarySubMenu?.activeIndex })">
                      <VisionIcon icon="arrow" :rotate="180" colour="black" size="x-small"/>
                      <span :class="bem('back-text')">
                        {{ activeSubMenu?.title || activeSecondarySubMenu?.title || '-' }}
                      </span>
                    </span>
                  </VisionLink>
                  <button :class="bem('close')" @click="pageStore.toggleNavSidebarOpen(false)">
                    <VisionIcon
                      colour="black"
                      icon="close"
                      size="x-small"
                    />
                  </button>
                </header>
                <ul :class="bem('items')">
                  <li
                    v-for="(nestedItem, nestedItemIndex) in secondaryNavigationItem?.nestedItems"
                    :key="'level-2-item-' + nestedItemIndex"
                    :class="bem('items-wrapper')"
                  >
                    <template v-if="nestedItem._modelApiKey === 'navigation_image_card_row'">
                      <div :class="bem('image-row', { count: nestedItem.items?.length })">
                        <div v-for="(imageCard, imageCardIndex) in nestedItem.items" :key="'level-2-image-card-row-' + imageCardIndex" :class="bem('image-card-wrapper')">
                          <VisionCard
                            :aspect-ratio="nestedItem.items?.length > 2 ? '1/1' : '16/9'"
                            :title="imageCard.cardTextPosition === 'bottom-card' ? imageCard.linkText : ''"
                            :link="buildInternalLink(imageCard)"
                            :class="bem('image-card', { titleBelowCard: imageCard.cardTextPosition === 'below-card' })"
                          >
                            <template
                              #image
                            >
                              <DatoCmsImage
                                :data="imageCard.image.responsiveImage"
                                object-fit="cover"
                                :object-position="`${imageCard.image.focalPoint.x * 100}% ${
                                  imageCard.image.focalPoint.y * 100
                                }%`"
                                layout="fill"
                                :class="bem('image')"
                                sizes="(max-width: 1280px) 100vw, 40vw"
                              />
                            </template>
                          </VisionCard>
                          <p v-if="imageCard.cardTextPosition === 'below-card' && imageCard.linkText" :class="bem('below-card-title')">
                            {{ imageCard.linkText }}
                            <span>
                              <VisionIcon icon="arrow" colour="black" size="x-small"/>
                            </span>
                          </p>
                        </div>
                      </div>
                    </template>

                    <a
                      v-else-if="
                        nestedItem._modelApiKey === 'navigation_link' &&
                        nestedItem.internalLink?.slug
                      "
                      :class="bem('item', { link: true })"
                      :href="buildInternalLink(nestedItem)"
                      @click="handleLevel2Event(nestedItem, secondaryNavigationItem.buttonText)"
                    >
                      <span :class="bem('item-text')">
                        {{ nestedItem.linkText }}
                      </span>
                      <VisionIcon icon="arrow" colour="black" size="small"/>
                    </a>
                  </li>
                </ul>
                <ul v-if="secondaryNavigationItem.secondaryNestedItems?.length" :class="bem('secondary-items')">
                  <li
                    v-for="(secondaryNestedItem, secondaryNestedItemIndex) in secondaryNavigationItem.secondaryNestedItems"
                    :key="'secondary-item-' + secondaryNestedItemIndex"
                  >
                    <a
                      v-if="
                        secondaryNestedItem._modelApiKey === 'navigation_link' &&
                        secondaryNestedItem.internalLink?.slug
                      "
                      :class="bem('secondary-item')"
                      :href="buildInternalLink(secondaryNestedItem)"
                      @click="handleLevel1Event(secondaryNestedItem.linkText)"
                    >
                      <span :class="bem('item-text')">
                        {{ secondaryNestedItem.linkText }}
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <div :class="bem('country-selector')">
            <span :class="bem('country-selector-flag')">
              <CountryFlag :country="$i18n.localeProperties.value.countryCode"/>
            </span>
            <VisionLink
              :is-button="true"
              :line-link="true"
              @click="showCurrencyMenu"
            >
              <span :class="bem('country-selector-text')">
                {{ $i18n.localeProperties.value.countryCode }}
                /
                {{ $i18n.localeProperties.value.currency }}
              </span>
            </VisionLink>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
import type { MainNavigationItems, SecondaryNavigationItems } from '~/gql/navigation.gql'
import { Image as DatoCmsImage } from 'vue-datocms'
 
const bem = useBEM('NavigationSidebar')
const pageStore = usePageStore()

const { $track, $i18n } = useNuxtApp()

const { buildInternalLink } = useUrlBuilder()

interface Props {
  mainNavigationItems: MainNavigationItems
  secondaryNavigationItems: SecondaryNavigationItems,
  defaultActiveSubmenu: { activeIndex: number, title: string } | null
  defaultActiveSecondarySubmenu: { activeIndex: number, title: string } | null
}

const props = defineProps<Props>()

const isOpen = computed(() => {
  return pageStore.navSidebarOpen
})

const activeSubMenu = ref<{ activeIndex: number, title: string } | null>(props.defaultActiveSubmenu)
const activeSecondarySubMenu = ref<{ activeIndex: number, title: string } | null>(props.defaultActiveSecondarySubmenu)

const activeSubMenuHasIncreasedWidth = computed(() => {
  if(!activeSubMenu?.value?.activeIndex && !activeSecondarySubMenu?.value?.activeIndex) return false

  const matchedActiveSubMenu = props.mainNavigationItems[activeSubMenu?.value?.activeIndex - 1] || props.secondaryNavigationItems[activeSecondarySubMenu?.value?.activeIndex - 1]

  if (matchedActiveSubMenu._modelApiKey !== 'navigation_button') return false

  return matchedActiveSubMenu.nestedItems.filter(
    nestedItem => nestedItem._modelApiKey === 'navigation_image_card_row'
  ).some(nestedItem => nestedItem.items?.length === 2)
})

onMounted(() => {
  if(isOpen.value) {
    pageStore.toggleBlockBodyScroll(isOpen.value)
  }
})

watch(() => isOpen.value, (visible) => {
  pageStore.toggleBlockBodyScroll(visible)

  if(!visible) {
    setTimeout(() => {
      activeSubMenu.value = null
    }, 300) // this timeout represents the transition out time of the sidebar
  }

  if (!visible) {
    $track.navigation.sideMenuClosed()
  } else {
    $track.navigation.sideMenuOpened()
  }
})

watch(() => props.defaultActiveSubmenu, (newValue) => {
  activeSubMenu.value = newValue
})

watch(() => props.defaultActiveSecondarySubmenu, (newValue) => {
  activeSecondarySubMenu.value = newValue
})

async function handleLevel1Event(target) {
  await $track.navigation.linkClicked({
    tierOne: target,
    location: 'header',
  })
}

async function handleLevel2Event(target, parent) {
  const targetText = target.buttonText ? target.buttonText : target.linkText

  await $track.navigation.linkClicked({
    tierTwo: targetText,
    tierOne: parent,
    location: 'header',
  })
}

async function toggleLevel2Menu(newActiveSubMenu: { activeIndex: number, title: string } | null) {
  activeSubMenu.value = newActiveSubMenu
  activeSecondarySubMenu.value = null
}

async function toggleLevel2SecondaryMenu(newActiveSubMenu: { activeIndex: number, title: string } | null) {
  activeSubMenu.value = null
  activeSecondarySubMenu.value = newActiveSubMenu
}

function showCurrencyMenu() {
  const sidebarStore = useSidebarStore()

  sidebarStore.toggleCountrySelector()
  $track.navigation.showCurrencyMenu({
    location: 'header',
    currentCurrency: $i18n.localeProperties.currency,
  })
}
</script>

<style lang="postcss">
.NavigationSidebar--open {
  .NavigationSidebar__drawer {
    @apply translate-x-0;
  }

  .NavigationSidebar__overlay {
    @apply pointer-events-auto bg-black/40;

    backdrop-filter: blur(5px);
  }
}

.NavigationSidebar--nested-drawer-open {
  @apply overflow-y-hidden;
}

.NavigationSidebar__drawer {
  @apply bg-white w-full md:w-[32%] md:min-w-[512px] left-0 -translate-x-full transition-all duration-[400ms] flex flex-col overflow-y-auto;

  container: nav-sidebar / inline-size;
}

.NavigationSidebar__drawer--increased-width {
  @apply md:w-3/5;
}

.NavigationSidebar__overlay {
  @apply w-full bg-black/0 pointer-events-none transition-all duration-200;

  backdrop-filter: blur(0);
}

.NavigationSidebar__drawer,
.NavigationSidebar__overlay {
  @apply fixed z-[12] top-0 h-full;
}

.NavigationSidebar__header {
  @apply flex justify-between pt-3 pb-5 md:pt-8 md:pb-12;
}

.NavigationSidebar__back-button {
  @apply pr-2;
}

.NavigationSidebar__close {
  @apply ml-auto pl-2;
}

.NavigationSidebar__back-button,
.NavigationSidebar__close {
  @apply pt-2 pb-2;
}

.NavigationSidebar__items {
  @apply flex gap-x-4 gap-y-6 flex-col pb-20;
}

.NavigationSidebar__item {
  @apply heading-2 md:text-xl flex items-center justify-between w-full;

  &--button,
  &--link {
    @apply mb-2;
  }
}

.NavigationSidebar__item,
.NavigationSidebar__secondary-item {
  @screen lg {
    &:hover {
      .NavigationSidebar__item-text {
        &:after {
          @apply scale-x-100 origin-left;
        }
      }
    }
  }
}

.NavigationSidebar__item-text {
  @apply relative block;

  @screen lg {
    &:after {
      @apply content-[''] absolute -bottom-1 left-0 w-full h-0.5
      bg-black
      scale-x-0 origin-right transition-transform duration-500;
    }
  }
}

.NavigationSidebar__header,
.NavigationSidebar__secondary-items,
.NavigationSidebar__items-wrapper,
.NavigationSidebar__country-selector {
  padding-left: var(--outer-gutter);
  padding-right: var(--outer-gutter);

  @screen md {
    @apply px-10;
  }
}

.NavigationSidebar__main {
  @apply relative flex flex-col h-full m-auto w-full;
}

.NavigationSidebar__secondary-items {
  @apply flex gap-6 md:gap-8 flex-col
    mt-auto;
}

.NavigationSidebar__utilities {
  @apply mt-auto pb-20;
}

.NavigationSidebar__secondary-item {
  @apply heading-4 inline-flex;
}

.NavigationSidebar__nested-drawer {
  @apply fixed top-0 w-full left-0 bg-white z-[1] flex-col overflow-y-auto -translate-x-full;

  height: 100%;

  .NavigationSidebar__secondary-items {
    @apply pb-20
  }
}

.NavigationSidebar__nested-drawer--active {
  @apply flex translate-x-0;

  .NavigationSidebar__image-card-wrapper {
    @apply opacity-100;
  }
}

.NavigationSidebar__country-selector {
  @apply mt-8 flex items-center gap-2;
}

.NavigationSidebar__country-selector-text {
  @apply font-fragment-mono text-xxs;
}

.NavigationSidebar__country-selector-flag {
  @apply w-4;
}

.NavigationSidebar__back-wrapper {
  @apply flex gap-4 font-fragment-mono text-mid-grey text-xxs items-center pointer-events-none opacity-0;
}

.NavigationSidebar__back-wrapper--visible {
  @apply opacity-100 pointer-events-auto;
}

.NavigationSidebar__back-text {
  @apply hidden md:block;
}

.NavigationSidebar__image-placeholder {
  @apply !h-[110%];
}

.NavigationSidebar__image-row {
  @apply flex gap-y-4 md:gap-y-6 gap-x-6 flex-wrap;
}

.NavigationSidebar__image-card-wrapper {
  @apply w-full grow flex flex-col gap-y-2
    opacity-0 transition-opacity duration-500 delay-200;
}

.NavigationSidebar__image-card {
  --vision-card-icon-button-display: visible;
}

.NavigationSidebar__image-card--title-below-card {
  --vision-card-icon-button-display: hidden;
}

.NavigationSidebar__below-card-title {
  @apply font-bold flex justify-between items-center gap-x-3;
}

.NavigationSidebar__image-row--count-1,
.NavigationSidebar__image-row--count-2 {
  .NavigationSidebar__image-card-wrapper {
    @container nav-sidebar (min-width: 550px) {
      @apply w-1/3;
    }
  }
}

.NavigationSidebar__image-row--count-3 {
  .NavigationSidebar__image-card-wrapper {
    @container nav-sidebar (max-width: 549px) {
      @apply w-1/3;
    }

    @container nav-sidebar (min-width: 550px) {
      @apply w-1/4;
    }
  }
}

.NavigationSidebar__image-row--count-4 {
  .NavigationSidebar__image-card-wrapper {
    @container nav-sidebar (min-width: 320px) {
      @apply w-1/3;
    }

    @container nav-sidebar (min-width: 700px) {
      @apply w-1/5;
    }
  }
}
</style>
